import { cmdName } from './labels';

export function transferPercent(expected?: number | null, actual?: number | null): number | null {
  if (expected == null || expected <= 0 || actual == null || !Number.isFinite(expected) || !Number.isFinite(actual)) return null;
  return Math.max(0, Math.min(100, Math.round(actual / expected * 100)));
}

/** 已有終態回覆時，不能因 TTL 經過就再顯示逾時。 */
export function syncCommandStatus(state?: string, expired?: boolean) {
  const resolved = state === 'succeeded' || state === 'failed' ? state : expired ? 'timed_out' : state;
  return { state: resolved, label: `命令${resolved ? cmdName(resolved) : '狀態待確認'}` };
}

export function syncStageLabel(stage: string): string {
  const labels: Record<string, string> = {
    scanning: '掃描中', scan_done: '掃描完成', uploading: '傳輸中',
    hashing: '驗證檔案', check_stored: '查詢保存狀態', complete: '掃描流程完成',
  };
  return labels[stage] ?? stage;
}
